<template>
  <div id="team-choice-form">
    <header class="panel__header mt-2">
      <div class="row">
        <div class="col-8">
          <h2 class="panel__title">Informe os dados da sua universidade:</h2>
        </div>
      </div>
    </header>

    <div id="form-dados-pessoais" class="row mt-4 mb-4">
      <div class="col-12">
        <div class="row">
          <div class="col-5">
            <select class="form-select" v-model="selectedInstitution" name="institution">
              <option value="">Universidade:</option>
              <option v-for="institution in institutions" :key="institution.id" :value="institution.id">
                ({{ institution.acronym }}) - {{ institution.name }} 
              </option>
            </select>
          </div>
          <div class="col-5">
            <select class="form-select" v-model="selectedProgram" name="program">
              <option value="">Curso:</option>
              <option v-for="program in programs" :key="program.id" :value="program.id"> {{ program.name }} </option>
            </select>
          </div>
          <div class="col-2">
            <input
              :class="{
                input: true,
                'is-invalid': errors.has('academic_register'),
              }"
              name="academic_register"
              v-validate="'required'"
              type="text"
              class="form-control"
              v-model="academicRegister"
              id="academic_register"
              placeholder="Matrícula:"
              value=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-alert variant="danger" :show="error.show" v-model="error.show">
          <div>{{ error.message }}</div>
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      selectedInstitution: "",
      selectedProgram: "",
      academicRegister: "",
      error: {
        show: false,
        message: ''
      }
    }
  },
  // mounted() {
  //   this.selectedInstitution = this.clube.educational_institutions[0]
  // },
  props: {
    user: {
      required: true,
      type: Object
    },
    clube: {
      required: true,
      type: Object
    },
  },
  methods: {
    submit() {
      if (!this.validate()) {
        this.error.show = true
        this.error.message = "Todos os campos precisam estar preenhcidos"
        return false
      } else {
        this.user.institution = this.selectedInstitution
        this.user.program = this.selectedProgram
        this.user.academic_register = this.academicRegister
        return true
      }
    },
    validate() {
      return this.selectedInstitution !== "" && this.selectedProgram !== "" && this.academicRegister !== ""
    },
  },
  computed: {
    programs() {
      const institution = this.institutions.find(i => i.id == this.selectedInstitution);

      if (institution === undefined) return [];

      const key = 'name';

      return [
        ...new Map(
          institution.programs.map(item => [item[key], item])
        ).values()
      ].sort((a, b) => a.name.localeCompare(b.name));
    },
    institutions() {
      return this.clube.educational_institutions
    }
  }
})
</script>